import gql from "graphql-tag";
import { invoiceFragment } from "./fragments";

export const CREATE_INVOICE = gql`
  mutation createInvoiceForTimesheets(
    $companyId: ID!
    $projectId: ID!
    $dueDate: Date!
    $uninvoicedTimesheetEntries: [TimesheetEntryInput!]
    $showDetailsOnInvoice: Boolean!
    $showOfferedOnInvoice: Boolean!
    $upUntil: Date!
  ) {
    createInvoiceForTimesheets(
      companyId: $companyId
      projectId: $projectId
      dueDate: $dueDate
      uninvoicedTimesheetEntries: $uninvoicedTimesheetEntries
      showDetailsOnInvoice: $showDetailsOnInvoice
      showOfferedOnInvoice: $showOfferedOnInvoice
      upUntil: $upUntil
    ) {
      status
      error
      data {
        ...InvoiceFragment
      }
    }
  }
  ${invoiceFragment}
`;

export const CREATE_INVOICE_FOR_EXPENSE = gql`
  mutation createInvoiceForExpense(
    $companyId: ID!
    $projectId: ID!
    $expenseId: ID!
    $dueDate: Date!
  ) {
    createInvoiceForExpense(
      companyId: $companyId
      projectId: $projectId
      expenseId: $expenseId
      dueDate: $dueDate
    ) {
      status
      error
      data {
        ...InvoiceFragment
      }
    }
  }
  ${invoiceFragment}
`;

export const SYNC_INVOICES = gql`
  mutation syncInvoices {
    syncInvoices {
      status
      error
      data {
        ...InvoiceFragment
      }
    }
  }
  ${invoiceFragment}
`;

export const UPDATE_INVOICE_PROJECT = gql`
  mutation updateInvoiceProject($id: ID!, $projectId: ID!) {
    updateInvoice(id: $id, projectId: $projectId) {
      status
      error
      data {
        ...InvoiceFragment
      }
    }
  }
  ${invoiceFragment}
`;

export const CLOSE_CREDIT_NOTES = gql`
  mutation closeCreditNotes($ids: [ID!]!) {
    closeCreditNotes(ids: $ids) {
      status
      error
      data {
        ...InvoiceFragment
      }
    }
  }
  ${invoiceFragment}
`;

export const UPDATE_INVOICE = gql`
  mutation updateInvoice(
    $id: ID!
    $comment: String
    $promisedDate: Date
    $collectionStatus: InvoiceCollectionStatus
    $assignedTo: ID
  ) {
    updateInvoice(
      id: $id
      comment: $comment
      promisedDate: $promisedDate
      collectionStatus: $collectionStatus
      assignedTo: $assignedTo
    ) {
      status
      error
      data {
        ...InvoiceFragment
        date
        dueDate
        promisedDate
        comment
        assignedTo {
          id
          firstName
        }
        company {
          id
          name
          client {
            id
            name
          }
        }
      }
    }
  }
  ${invoiceFragment}
`;

export const UPDATE_ASSIGNED_TO = gql`
  mutation updateAssignedTo($invoiceIds: [ID!]!, $assignedTo: ID) {
    updateAssignedTo(invoiceIds: $invoiceIds, assignedTo: $assignedTo) {
      status
      error
    }
  }
`;
